import React from "react";
import "./Blogfront.css";
const Blogfront = () => {
  return (
    <div>
      <div className="blog-front">
        <div className="blog-front-content">
          <p>
            BizTalk Server latest news, updates on our product features and
            release information
          </p>
        </div>
        <div className="blog-front-bg">
          <img src="/images/blog.svg" />
        </div>
      </div>
    </div>
  );
};
export default Blogfront;
